module.exports = __webpack_public_path__ + "static/img/machine.a0ba03f.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/home/customer/machine.png
// module id = NBcy
// module chunks = 1